import { Auth } from 'aws-amplify';
import { publicRuntimeConfig } from '../config';
import { awsAuthConfig } from '../../aws-auth-config';

export const sendAdfsLogin = () => {
    awsAuthConfig();
    const authConfig = Auth.configure();
    const { userPoolWebClientId } = authConfig;
    const { domain, redirectSignIn } = authConfig.oauth;
    const { name, grantFlow } = publicRuntimeConfig.settings;
    const url = `https://${domain}/oauth2/authorize?identity_provider=${name}&redirect_uri=${redirectSignIn}&response_type=${grantFlow}&client_id=${userPoolWebClientId}`;
    sessionStorage.setItem('bo_sess', true); // Launch hosted UI
    window.location.assign(url);
};
